var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnicianRoleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 393.244,
    height: 491.075
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Technician"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technician",
    clipPath: "url(#clip-Technician)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(203.242 154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10756",
    "data-name": "Path 10756",
    d: "M271.787,496.6H160.049a34.482,34.482,0,0,0-55.63,10.477,5.333,5.333,0,0,0,4.871,7.523h18.64a6.583,6.583,0,1,1-.006,13.165H109.286a5.336,5.336,0,0,0-4.867,7.516,34.467,34.467,0,0,0,55.613,10.473H271.778a34.348,34.348,0,0,0,24.164,9.892l-.007,0a34.512,34.512,0,0,0,31.446-20.362,5.335,5.335,0,0,0-4.851-7.518H303.878a6.583,6.583,0,1,1,0-13.167h18.647a5.335,5.335,0,0,0,4.856-7.518A34.456,34.456,0,0,0,271.787,496.6M264.4,507.264a34.459,34.459,0,0,0,0,27.814h-97a34.378,34.378,0,0,0,0-27.814ZM119.5,538.424h0l0,0,0,0h8.428a17.251,17.251,0,1,0,0-34.5h-8.43a23.79,23.79,0,0,1,34.137,33.086l-.011.011c-.161.181-.32.363-.488.541a23.794,23.794,0,0,1-33.637.863m192.833-34.5h-8.445a17.25,17.25,0,0,0,0,34.5h8.445a23.8,23.8,0,1,1,0-34.5",
    transform: "translate(-19.284 -90.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10757",
    "data-name": "Path 10757",
    d: "M360.318,295.646a114.293,114.293,0,0,0-79.6-34.477,6.227,6.227,0,0,0-1.088-.014l-.444-.007c-.3,0-.608-.011-.914-.011H255.95V238.26a88.986,88.986,0,0,0,30.024-60.525h7.74a28.338,28.338,0,0,0,28.253-28.255V135.67a28.352,28.352,0,0,0-15.323-25.117,41.82,41.82,0,0,0,.544-6.626l0-11.435a.89.89,0,0,0,0-.109A92.772,92.772,0,0,0,214.7,0H178.543A92.741,92.741,0,0,0,86.057,92.491v11.437a41.627,41.627,0,0,0,.545,6.623,28.341,28.341,0,0,0-15.325,25.12v13.812a28.326,28.326,0,0,0,28.248,28.251h7.752a88.97,88.97,0,0,0,30.01,60.518v22.882H114.961c-.31,0-.619.006-.927.011l-.45.008a5.984,5.984,0,0,0-1.053.013A115.091,115.091,0,0,0,0,376.1V484.532a6.559,6.559,0,0,0,6.549,6.543H386.691a6.566,6.566,0,0,0,6.554-6.557V376.108a114.278,114.278,0,0,0-32.927-80.462M302.393,123.27a15.177,15.177,0,0,1,6.47,12.4v13.8a15.188,15.188,0,0,1-15.149,15.145H286.22v-24.64a41.4,41.4,0,0,0,16.172-16.709M178.119,13.111H214.7a79.662,79.662,0,0,1,79.1,72.824H99.438a79.672,79.672,0,0,1,78.681-72.824M107.028,164.624h-7.5A15.178,15.178,0,0,1,84.386,149.48v-13.8a15.167,15.167,0,0,1,6.469-12.4,41.4,41.4,0,0,0,16.173,16.707Zm8.94-34.788a28.481,28.481,0,0,1-15.4-17.087c-.045-.152-.094-.3-.149-.45a28.426,28.426,0,0,1-1.264-8.371v-4.88H294.078v4.88a28.464,28.464,0,0,1-16.746,25.882,6.755,6.755,0,0,0-.7.311,28.25,28.25,0,0,1-10.946,2.2H127.551a28.253,28.253,0,0,1-10.93-2.192,5.681,5.681,0,0,0-.653-.291m4.173,41.343V144.751a41.7,41.7,0,0,0,7.411.678H260.509l-.013.006,5.188-.006a41.7,41.7,0,0,0,7.422-.678v26.427l0,.1a76.392,76.392,0,0,1-26.991,58.21,6.547,6.547,0,0,0-1.68,1.388,75.642,75.642,0,0,1-47.813,16.79,76.669,76.669,0,0,1-47.869-16.835,6.527,6.527,0,0,0-1.585-1.308,76.38,76.38,0,0,1-27.031-58.342m122.7,76.726v17.813l-46.218,69.391L150.4,265.722V247.9a89.426,89.426,0,0,0,46.219,12.874l.263,0h0A89.442,89.442,0,0,0,242.837,247.9M119.729,274.246h20.607l50.834,76.32a6.553,6.553,0,0,0,10.912,0L252.9,274.247H273.51v96.444H119.729ZM61.776,477.96H13.112V376.106a102.46,102.46,0,0,1,48.664-86.825Zm256.574,0H74.89V282.482a101.226,101.226,0,0,1,31.726-7.883V377.251a6.566,6.566,0,0,0,6.557,6.553h166.9a6.564,6.564,0,0,0,6.554-6.557V274.6a101.233,101.233,0,0,1,31.727,7.879Zm61.785,0H331.462V289.277A102.454,102.454,0,0,1,380.135,376.1Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 399.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.5,
    cy: 399.5,
    r: 391,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianRoleIcon);
export default __webpack_public_path__ + "static/media/TechnicianRoleIcon.9347674c0aba85544711c9fecca6cc02.svg";
export { ForwardRef as ReactComponent };